<template>
  <section v-if="hasDisbursementDocuments" class="detail-data-wrapper mt-2 mb-4">
    <h6 class="form-title">DOKUMEN</h6>
    <div v-if="statementDocuments.length" class="mb-3">
      <p class="detail-label mb-2">Surat Pernyataan</p>
      <b-button
        v-for="(documentUrl, index) in statementDocuments"
        :key="documentUrl"
        size="sm"
        variant="pgiBtn"
        class="mr-2 mb-2"
        @click="openStatementPreview(documentUrl)"
      >
        {{ statementButtonText(index) }}
      </b-button>
    </div>
    <div v-if="refundDocuments.length">
      <p class="detail-label mb-2">Bukti Pengembalian Nasabah</p>
      <ModalFoto isButton withLength title="Bukti Pengembalian Nasabah" :photos="refundDocuments" />
    </div>
    <div v-if="transferDocuments.length">
      <p class="detail-label mb-2">Bukti Transfer Kekurangan</p>
      <ModalFoto isButton withLength title="Bukti Transfer Kekurangan" :photos="transferDocuments" />
    </div>

    <b-modal id="modal-preview-surat-pernyataan-document" size="xl" title="Surat Pernyataan" ok-only ok-title="Tutup">
      <iframe
        v-if="activeStatementDocument"
        :src="activeStatementDocument"
        class="statement-preview-frame"
        title="Surat Pernyataan"
      />
    </b-modal>
  </section>
</template>

<script>
import ModalFoto from '@/components/modals/ModalFoto'
import { parseDocumentUrls } from './disbursementPendingUtils'

export default {
  name: 'DisbursementPendingDocumentSection',
  components: {
    ModalFoto,
  },
  props: {
    disbursementPending: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    statementDocuments() {
      return parseDocumentUrls(this.disbursementPending.pathFotoStatement)
    },
    refundDocuments() {
      return parseDocumentUrls(this.disbursementPending.pathFotoRefund)
    },
    transferDocuments() {
      return parseDocumentUrls(this.disbursementPending.pathFotoTransfer)
    },
    hasDisbursementDocuments() {
      return this.statementDocuments.length || this.refundDocuments.length || this.transferDocuments.length
    },
  },
  data() {
    return {
      activeStatementDocument: '',
    }
  },
  methods: {
    statementButtonText(index) {
      if (this.statementDocuments.length === 1) return 'Lihat Surat'

      return `Lihat Surat ${index + 1}`
    },
    openStatementPreview(documentUrl) {
      this.activeStatementDocument = documentUrl
      this.$bvModal.show('modal-preview-surat-pernyataan-document')
    },
  },
}
</script>

<style scoped>
.form-title {
  color: #20a8d8;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 16px;
}

.detail-label {
  color: #73818f;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.statement-preview-frame {
  border: 0;
  height: 75vh;
  width: 100%;
}
</style>
